import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Button, Grid } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const taxInfo = {
	amount: 0,
	taxDeduction: 0,
	taxAmount: 0,
	amBidrag: 0.08,
	total: 0,
};

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: '#ccc',
		height: '100vh',

		[theme.breakpoints.down('xs')]: {
			paddingBottom: '200px',
		},
	},

	toolbarStyleWrapper: {
		width: '100%',
	},

	toolbarStyle: {
		maxWidth: '960px',
		margin: '0 auto',
	},

	contentWrapper: {
		maxWidth: '960px',
		margin: '100px auto',
		padding: '15px',

		[theme.breakpoints.down('xs')]: {
			margin: '30px auto',
		},
	},

	title: {
		textTransform: 'uppercase',
		letterSpacing: '1.8px',
		fontWeight: 500,
	},

	paperStyle: {
		padding: '15px',
		minHeight: '225px',
	},

	table: {
		maxWidth: 850,
	},

	inputFieldStyle: {
		marginBottom: '20px',
	},

	margin: {
		margin: theme.spacing(1),
	},

	resetBtnWrapper: {
		marginBottom: '28px',
	},
}));

const Indkomsttype = () => {
	const classes = useStyles();
	const [calculateTax, setCalculateTax] = useState({ taxInfo });

	const handleChangeInput = (event) => {
		let value = parseFloat(event.target.value);

		if (isNaN(value)) {
			value = '';
		}

		setCalculateTax({
			...calculateTax,
			[event.target.name]: value,
		});
	};

	const onReset = () => {
		setCalculateTax({
			...calculateTax,
			amount: '',
			taxDeduction: '',
			taxAmount: '',
		});
	};

	const { amount, taxDeduction, taxAmount } = calculateTax;
	const { amBidrag } = taxInfo;

	return (
		<div className={classes.root}>
			<AppBar position='static'>
				<div className={classes.toolbarStyleWrapper}>
					<Toolbar className={classes.toolbarStyle}>
						<Typography variant='h6' className={classes.title}>
							skatteberegner
						</Typography>
					</Toolbar>
				</div>
			</AppBar>
			<div className={classes.contentWrapper}>
				<Grid container spacing={3}>
					<Grid item lg={3} md={3} sm={3} xs={12}>
						<Paper className={classes.paperStyle}>
							<form noValidate autoComplete='off'>
								<div>
									<TextField
										id='outlined-textarea'
										label='Skriv Beløb'
										multiline
										variant='outlined'
										onChange={handleChangeInput}
										name='amount'
										value={calculateTax.amount}
										type='number'
										fullWidth={true}
										className={classes.inputFieldStyle}
									/>
									<TextField
										id='outlined-textarea'
										label='Trækprocent'
										multiline
										variant='outlined'
										onChange={handleChangeInput}
										name='taxAmount'
										value={calculateTax.taxAmount}
										type='number'
										fullWidth={true}
										className={classes.inputFieldStyle}
									/>
									<TextField
										id='outlined-textarea'
										label='Fradrag'
										multiline
										variant='outlined'
										onChange={handleChangeInput}
										name='taxDeduction'
										value={calculateTax.taxDeduction}
										type='number'
										fullWidth={true}
										className={classes.inputFieldStyle}
									/>
								</div>
							</form>
							<div className={classes.resetBtnWrapper}>
								<Button
									onClick={onReset}
									variant='contained'
									color='primary'
									fullWidth={true}
								>
									Reset
								</Button>
							</div>
						</Paper>
					</Grid>
					<Grid item lg={9} md={9} sm={9} xs={12}>
						<TableContainer component={Paper}>
							<Table className={classes.table} aria-label='simple table'>
								<TableHead>
									<TableRow>
										<TableCell>Poster</TableCell>
										<TableCell align='right'>Grundlag</TableCell>
										<TableCell align='right'>Sats</TableCell>
										<TableCell align='right'>Beløb</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									<TableRow>
										<TableCell component='th' scope='row'>
											Løn
										</TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'>
											{amount > 0 ? amount : ''}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='th' scope='row'>
											AM-Bidrag
										</TableCell>
										<TableCell align='right'>
											{amount > 0 ? amount : ''}
										</TableCell>
										<TableCell align='right'>
											{amount > 0 ? amBidrag * 100 + '%' : ''}
										</TableCell>
										<TableCell align='right'>
											{amount > 0 ? '- ' : ''}
											{amount > 0 ? amount * amBidrag : ''}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='th' scope='row'>
											Fradrag
										</TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'>
											{taxDeduction > 0 && taxDeduction}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='th' scope='row'>
											Skat
										</TableCell>
										<TableCell align='right'>
											{amount && taxDeduction && taxAmount > 0
												? amount - (amount * amBidrag + taxDeduction)
												: ''}
										</TableCell>
										<TableCell align='right'>
											{taxAmount > 0 && taxAmount}
											{taxAmount > 0 ? '%' : ''}
										</TableCell>
										<TableCell align='right'>
											{amount && taxDeduction && taxAmount > 0 ? '- ' : ''}
											{amount && taxDeduction && taxAmount > 0
												? ((amount - (amount * amBidrag + taxDeduction)) *
														taxAmount) /
												  100
												: ''}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell component='th' scope='row'>
											Udbetaling
										</TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'></TableCell>
										<TableCell align='right'>
											{amount && taxDeduction && taxAmount > 0
												? amount -
												  ((amount - (amount * amBidrag + taxDeduction)) *
														taxAmount) /
														100 -
												  amount * amBidrag
												: ''}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default Indkomsttype;
